<script>
  /* eslint-disable no-use-before-define */
  import lysSvg from '../../assets/lys.svg'
  import presangSvg from '../../assets/presang.svg'
  import dompappSvg from '../../assets/dompapp.svg'
  import kuleSvg from '../../assets/kule.svg'
  import notteknekkerSvg from '../../assets/notteknekker.svg'

  export let data

  const svg = {
    lys: lysSvg,
    presang: presangSvg,
    dompapp: dompappSvg,
    kule: kuleSvg,
    notteknekker: notteknekkerSvg,
  }
</script>

<img class="decoration" src={svg[data.name]} alt={data.alternativeText} />

<style>
  .decoration {
    margin-top: 25px;
    z-index: 1;
  }
</style>
